// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"ebc15142","167":"be8a98c8","276":"264c6823","339":"2e3d968e","351":"55e6fcaa","368":"941ad673","438":"53d629a6","488":"ca2d0e9a","497":"bf1de5ba","501":"65972676","524":"acdd6803","837":"6b794a94","970":"0ddd5d2b"}[chunkId] + ".chunk.js";
};